"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var index_1 = require("../index");

var ContactFormValidationSchema_1 = require("./ContactFormValidationSchema");

var FieldLabels_enum_1 = require("./FieldLabels.enum");

var FieldNames_enum_1 = require("./FieldNames.enum");

var fieldsValues_1 = require("./fieldsValues");

var ContactForm =
/** @class */
function (_super) {
  __extends(ContactForm, _super);

  function ContactForm() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleSubmit = function (values, actions) {
      var setSubmitting = actions.setSubmitting,
          setFieldTouched = actions.setFieldTouched;
      var submitMessage = _this.props.submitMessage;
      setFieldTouched(FieldNames_enum_1.FieldNames.subject);
      setSubmitting(true);
      submitMessage(values);
    };

    _this.renderForm = function (props) {
      var updating = _this.props.updating;
      var isSubmitting = props.isSubmitting,
          isValid = props.isValid,
          errors = props.errors,
          handleSubmit = props.handleSubmit;
      var submitButtonDisabled = !isValid || updating || isSubmitting;

      if (isSubmitting && !updating) {
        props.setSubmitting(false);
      }

      return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(components_lib_1.FormFieldContainer, null, react_1.default.createElement(components_lib_1.FormField, __assign({}, props, {
        name: FieldNames_enum_1.FieldNames.subject
      }), react_1.default.createElement(formik_1.Field, {
        component: components_lib_1.FormPicker,
        name: FieldNames_enum_1.FieldNames.subject,
        label: FieldLabels_enum_1.FieldLabels.subject,
        type: components_lib_1.FormPickerComponent.type.singleSelect,
        options: fieldsValues_1.subjectValues,
        disabled: isSubmitting || updating,
        isError: !errors[FieldNames_enum_1.FieldNames.subject]
      }))), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.name,
        label: FieldLabels_enum_1.FieldLabels.name,
        onChange: function onChange() {
          return _this.handleChange(props);
        },
        isDisabled: isSubmitting || updating
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.email,
        label: FieldLabels_enum_1.FieldLabels.email,
        onChange: function onChange() {
          return _this.handleChange(props);
        },
        isDisabled: isSubmitting || updating
      }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
        name: FieldNames_enum_1.FieldNames.body,
        label: FieldLabels_enum_1.FieldLabels.body,
        multiline: true,
        numberOfLines: 5,
        onChange: function onChange() {
          return _this.handleChange(props);
        },
        isDisabled: isSubmitting || updating,
        preventSubmitOnEnter: true
      }, props)), react_1.default.createElement(index_1.ContactPageButtonRow, null, react_1.default.createElement(index_1.ContactFormButtonContainer, null, react_1.default.createElement(components_lib_1.Button, {
        type: components_lib_1.ButtonTypeEnum.primary,
        text: FieldLabels_enum_1.FieldLabels.submit,
        onPress: handleSubmit,
        uppercase: true,
        disabled: submitButtonDisabled,
        loading: isSubmitting || updating
      }))));
    };

    return _this;
  }

  ContactForm.prototype.setInitialFormValues = function () {
    return {
      name: '',
      email: '',
      subject: '',
      body: ''
    };
  };

  ContactForm.prototype.handleChange = function (props) {
    var setFieldTouched = props.setFieldTouched;
    setFieldTouched(FieldNames_enum_1.FieldNames.subject);
  };

  ContactForm.prototype.render = function () {
    return react_1.default.createElement(formik_1.Formik, {
      initialValues: this.setInitialFormValues(),
      onSubmit: this.handleSubmit,
      validationSchema: ContactFormValidationSchema_1.ContactFormValidationSchema,
      render: this.renderForm
    });
  };

  return ContactForm;
}(react_1.default.Component);

exports.ContactForm = ContactForm;